import { RouteContentLoading } from "@ilabel/ui";

export function AppPageLoading() {
  return (
    <RouteContentLoading
      ariaLabel="页面加载中"
      description="页面加载中…"
      indicator="bar"
      indicatorPlacement="after"
    />
  );
}
